import React, { useState, useMemo, useEffect } from "react";
import { generateMonthsFrom2025, useIsMobile } from "../../../utilities";
import { FaCheckCircle, FaDownload } from "react-icons/fa";
import Select from "react-select";
import { formatToIndianNumber } from "../../../utilities";
import { FaUserGroup } from "react-icons/fa6";
import { SiVirustotal } from "react-icons/si";
import { IoIosWarning } from "react-icons/io";
import DebounceSmallSearchInput from "../../Constant/DebounceSmallSearchInput";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import Pagination from "../../Constant/Pagination";
import { CancelRequest } from "../../../services/AxiosInstance";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../../../Images/dcwlogo.png";
import { BsFileEarmarkPdfFill } from "react-icons/bs";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import { Dropdown } from "react-bootstrap";
import GlobalSearchableDropdown from "../../Constant/SearchableDropdown";
import {
  checkDoorStepEmployeePayroll,
  createDoorStepEmployeePayroll,
  getDoorStepEmployeePayroll,
  getDoorStepEmployeePayrollExportApi,
} from "../../../services/DoorStepEmployeeService";
import DoorStepEmployeeSalaryTable from "./DoorStepEmployeeSalaryTable";
import DoorStepEmployeePaymentModal from "./DoorStepEmployeePaymentModal";
const mappEdKey = {
  customer_referral: "Customer Referral",
  employee_referral: "Employee Referral",
  other: "Other",
  fuel_allowance: "Fuel Allowance",
  fuel_deduction: "Fuel Deduction",
  leave: "Leave",
  penalty: "Penalty",
  advance_deduction: "Advance Deduction",
  other_deduction: "Other",
};
const generateCombinedPDF = (payrolls) => {
  const doc = new jsPDF();

  payrolls.forEach((payroll, index) => {
    if (index > 0) doc.addPage();

    const emp = payroll.employee;
    const att = payroll.attendance_summary;
    const snap = payroll.payroll_snapshot;

    // --- HEADER ---
    doc.addImage(logo, "PNG", 15, 10, 25, 25);

    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.setTextColor(0, 0, 0);
    doc.text("Daily Car Wash", 192, 15, { align: "right" });

    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(80);

    const headerBlock = [
      "Khata No - 1988, Plot - 8472, Ghagudi Rd, Ghatikia,",
      "Bhubaneswar, Shankarpur, Odisha 751029",
      "Phone: +9197776 32222",
      "Email: info@dailycarwash.in",
      "Website: https://user.dailycarwash.in/",
    ];

    let headerY = 22;
    headerBlock.forEach((line) => {
      doc.text(line, 192, headerY, { align: "right" });
      headerY += 5;
    });

    // --- Separator Line (below header) ---
    headerY += 5; // extra gap
    doc.setDrawColor(180);
    doc.line(15, headerY, 195, headerY);

    // --- Title ---
    headerY += 12; // spacing below line
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.setTextColor(0, 0, 0);
    doc.text("Salary Slip", 105, headerY, { align: "center" });

    // --- Pay Period ---
    headerY += 6;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text(
      `Pay Period: ${payroll.pay_period_start} to ${payroll.pay_period_end} | Payment Date: ${payroll.payment_date}`,
      105,
      headerY,
      { align: "center" }
    );

    // --- Employee & Attendance ---
    let y = headerY + 15;
    doc.setFont("helvetica", "bold");
    doc.text("Employee Details", 15, y);
    doc.text("Attendance Details", 120, y);

    doc.setFont("helvetica", "normal");
    y += 8;

    // Employee (left)
    doc.text(`Name: ${emp.name}`, 15, y);
    doc.text(`Mobile: ${emp.mobile_number}`, 15, y + 7);
    doc.text(`Aadhaar: ${emp.adhar_no}`, 15, y + 14);
    doc.text(`PAN: ${emp.pan_no || "-"}`, 15, y + 21);
    doc.text(`Designation: ${emp.designation}`, 15, y + 28);
    doc.text(`Apartment: ${emp.apartment_type}`, 15, y + 35);
    doc.text(`Bank: ${emp.bank_name || "-"}`, 15, y + 42);
    doc.text(`A/C: ${emp.bank_account_number || "-"}`, 15, y + 49);
    doc.text(`IFSC: ${emp.bank_ifsc || "-"}`, 15, y + 56);

    // Attendance (right)
    doc.text(`Total Days: ${att.total_days_in_month}`, 120, y);
    doc.text(`Working Days: ${att.working_days}`, 120, y + 7);
    doc.text(`Holidays: ${att.holidays}`, 120, y + 14);
    doc.text(`Paid Leaves: ${att.paid_leaves}`, 120, y + 21);
    doc.text(`Unpaid Leaves: ${att.unpaid_leaves}`, 120, y + 28);
    doc.text(`Late Comings: ${att.late_comings}`, 120, y + 35);
    doc.text(`Days Paid: ${att.total_days_paid}`, 120, y + 42);

    // --- Salary Table ---
    const earnings = [
      ...Object.entries(snap.allowances_breakdown || {}),
      ...Object.entries(snap.earnings_breakdown || {}),
    ].map(([key, value]) => [mappEdKey[key] || key, value]);

    const deductions = Object.entries(snap.deductions_breakdown || {}).map(
      ([key, value]) => [mappEdKey[key] || key, value]
    );
    const maxRows = Math.max(earnings.length, deductions.length);

    const rows = [];
    for (let i = 0; i < maxRows; i++) {
      rows.push([
        earnings[i] ? earnings[i][0] : "",
        earnings[i] ? earnings[i][1] : "",
        deductions[i] ? deductions[i][0] : "",
        deductions[i] ? deductions[i][1] : "",
      ]);
    }

    autoTable(doc, {
      startY: y + 65,
      theme: "grid",
      head: [["Earnings", "Amount (Rs.)", "Deductions", "Amount (Rs.)"]],
      body: rows,
      foot: [
        [
          "Gross Earnings",
          snap.earned_gross,
          "Total Deductions",
          snap.total_deductions,
        ],
        ["", "", "Net Salary (Rs.)", snap.net_pay],
      ],
      styles: { fontSize: 9, lineColor: [200, 200, 200], lineWidth: 0.1 },
      headStyles: { fillColor: [41, 128, 185], textColor: 255 },
      footStyles: {
        fillColor: [245, 245, 245],
        textColor: 0,
        fontStyle: "bold",
      },
      columnStyles: {
        1: { halign: "right" },
        3: { halign: "right" },
      },
    });

    // --- Payment Status + Signature ---
    const finalY = doc.lastAutoTable.finalY + 15;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.setTextColor(0, 0, 0);
    doc.text("Payment Status:", 15, finalY);
    doc.setFont("helvetica", "normal");
    doc.text(snap.payment_status, 65, finalY);

    doc.setFont("helvetica", "bold");
    doc.text("Paid At:", 15, finalY + 7);
    doc.setFont("helvetica", "normal");
    doc.text(snap.paid_at ? snap.paid_at.split("T")[0] : "--", 65, finalY + 7);

    const sigX = 150;
    doc.line(sigX, finalY, sigX + 40, finalY);
    doc.setFontSize(9);
    doc.text("Authorized Signature", sigX + 20, finalY + 6, {
      align: "center",
    });

    // --- Footer ---
    doc.setFontSize(8);
    doc.setTextColor(120);
    doc.text(
      "This is a computer-generated salary slip and requires no physical signature.",
      105,
      285,
      { align: "center" }
    );
  });

  doc.save("DoorStepEmployees_SalarySlips.pdf");
};

export default function DoorStepSalary() {
  const isMobile = useIsMobile();
  const [exportLoading, setExportLoading] = useState(false);
  const [summary, setSummary] = useState(null);
  const [isPayrollCreated, setIsPayrollCreated] = useState(false);
  const [checkLoading, setCheckLoading] = useState(false);
  const [careatePayrollLoading, setCreatePayrollLoading] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(
    generateMonthsFrom2025()[0]
  );
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [param, setParam] = useState({
    page: "1",
    page_size: "50",
    query: "",
    year: String(new Date().getFullYear()),
    month: String(new Date().getMonth() + 1),
  });

  const handleMonthChange = (option) => {
    setSelectedMonth(option);
    setSelectedEmployees([]);
    setSelectedEmployee(null);
    const [monthName, yearStr] = option.value.split(" ");
    const year = parseInt(yearStr, 10);
    const selectedMonthIndex = new Date(
      `${monthName} 1, ${yearStr}`
    ).getMonth();
    setParam((prev) => ({
      ...prev,
      year: String(year),
      month: String(selectedMonthIndex + 1),
    }));
  };

  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [isBulkPaymentModalOpen, setIsBulkPaymentModalOpen] = useState(false);

  // Toggle  for bulk
  const toggleEmployeeSelection = (employee) => {
    setSelectedEmployees((prev) =>
      prev.some((item) => item?.employee?.id == employee?.employee?.id)
        ? prev.filter((emp) => emp?.employee?.id !== employee?.employee?.id)
        : [...prev, employee]
    );
  };

  // Single payment
  const handlePayEmployee = (employee) => {
    setSelectedEmployee(employee);
    setIsPaymentModalOpen(true);
  };

  const handlePaymentSuccess = () => {
    setIsPaymentModalOpen(false);
    setSelectedEmployee(null);
    setIsBulkPaymentModalOpen(false);
    setSelectedEmployees([]);
    getPayoll();
  };

  // Bulk payment
  const handleBulkPayment = () => {
    if (selectedEmployees.length > 0) {
      setIsBulkPaymentModalOpen(true);
    }
  };

  // Select all pending
  const handleSelectAllEmployees = (isSelected) => {
    if (isSelected) {
      const pendingEmployee = data.filter(
        (emp) =>
          emp?.payroll_snapshot?.payment_status?.toLowerCase() === "pending"
      );
      setSelectedEmployees(pendingEmployee);
    } else {
      setSelectedEmployees([]);
    }
  };

  //get payroll data
  const getPayoll = () => {
    setLoading(true);
    getDoorStepEmployeePayroll(param)
      .then((res) => {
        setData(res?.data?.results?.payroll_data || []);
        setTotal(res?.data?.count || 0);
        setSummary(res?.data?.results?.summary || null);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getPayoll();
  }, [param]);

  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };

  //check payroll available or not
  const checkPayroll = (data) => {
    setCheckLoading(true);
    checkDoorStepEmployeePayroll(data)
      .then((res) => {
        setIsPayrollCreated(res?.data?.payroll_created);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setCheckLoading(false);
      });
  };

  useEffect(() => {
    const [monthName, yearStr] = selectedMonth.value.split(" ");
    const year = parseInt(yearStr, 10);
    const selectedMonthIndex = new Date(
      `${monthName} 1, ${yearStr}`
    ).getMonth();

    checkPayroll({
      year: String(year),
      month: String(selectedMonthIndex + 1),
    });
  }, [selectedMonth]);

  //payroll-create
  const handleCreatePayroll = () => {
    setCreatePayrollLoading(true);
    const [monthName, yearStr] = selectedMonth.value.split(" ");
    const year = parseInt(yearStr, 10);
    const selectedMonthIndex = new Date(
      `${monthName} 1, ${yearStr}`
    ).getMonth();
    createDoorStepEmployeePayroll({
      year: String(year),
      month: String(selectedMonthIndex + 1),
    })
      .then((res) => {
        toast.success("Payroll created successfully");
        setIsPayrollCreated(true);
        getPayoll();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => setCreatePayrollLoading(false));
  };

  const handleExport = () => {
    setExportLoading(true);
    getDoorStepEmployeePayrollExportApi({ ...param, export: true })
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "DorSetp-Employee-Payroll-report.xlsx";

        // Append to DOM to make it more consistent
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setExportLoading(false);
      });
  };
  return (
    <>
      {/* Header */}
      <div className="card mb-3">
        <div className="d-flex justify-content-between align-items-start gap-2 flex-start p-3 flex-wrap">
          <div className="d-flex flex-column">
            <h5 className="mb-0">Salary Management</h5>
            <span
              className="text-dark fw-medium"
              style={{ fontSize: "0.8rem" }}
            >
              Manage your payments
            </span>
          </div>
          <div className="d-flex gap-2 align-items-center">
            <div>
              <Select
                placeholder="Select Month"
                classNamePrefix="select"
                className="react-select"
                options={generateMonthsFrom2025()}
                onChange={handleMonthChange}
                value={selectedMonth}
              />
            </div>

            <Dropdown>
              <Dropdown.Toggle
                variant="success"
                id="dropdown-basic"
                disabled={exportLoading || data?.length == 0}
              >
                {exportLoading ? (
                  <Spinner animation="border" size="sm" className="me-1" />
                ) : (
                  <FaDownload className="me-1" />
                )}
                Export
              </Dropdown.Toggle>

              <Dropdown.Menu
                align="end"
                className="shadow-sm mt-1"
                style={{
                  zIndex: 1050,
                  minWidth: "120px",
                }}
              >
                <Dropdown.Item onClick={() => generateCombinedPDF(data)}>
                  <BsFileEarmarkPdfFill className="me-1" />
                  PDF
                </Dropdown.Item>
                <Dropdown.Item onClick={handleExport}>
                  <PiMicrosoftExcelLogoFill className="me-1" />
                  Excel
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        <div className="row g-3 py-2 px-3">
          <div className="col-6 col-lg-3">
            <div
              className="card shadow-sm rounded-4 h-100 overflow-hidden"
              style={{
                background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
                position: "relative",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow =
                  "0 10px 20px rgba(0, 0, 0, 0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(0, 0, 0, 0.1)";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-15%",
                  right: "-15%",
                  width: "140px",
                  height: "140px",
                  background:
                    "linear-gradient(135deg, rgba(239, 68, 68, 0.15), rgba(254, 202, 202, 0.1))",
                  borderRadius: "50%",
                  filter: "blur(50px)",
                  opacity: "0.7",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: "-20%",
                  left: "-20%",
                  width: "120px",
                  height: "120px",
                  background:
                    "linear-gradient(135deg, rgba(239, 68, 68, 0.12), rgba(254, 202, 202, 0.08))",
                  borderRadius: "50%",
                  filter: "blur(40px)",
                  opacity: "0.5",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "4px",
                  background: "linear-gradient(90deg, #ef4444, #f87171)",
                  borderRadius: "4px 4px 0 0",
                }}
              ></div>
              <div
                className={`card-body d-flex justify-content-between align-items-center ${
                  isMobile ? "p-3" : "p-4"
                }`}
              >
                <div>
                  <h5
                    className="fw-bold m-0 text-primary"
                    style={{ fontSize: "1.2rem" }}
                  >
                    {summary?.total_employees || 0}
                  </h5>
                  <span className="fw-medium" style={{ fontSize: "0.85rem" }}>
                    Total Employees
                  </span>
                </div>
                <span
                  className="d-none rounded-3 d-sm-flex justify-content-center align-items-center"
                  style={{
                    padding: "0.7rem",
                    background: "linear-gradient(135deg, #ef4444, #f87171)",
                    boxShadow: "0 6px 15px rgba(239, 68, 68, 0.3)",
                  }}
                >
                  <FaUserGroup size={22} color="white" />
                </span>
              </div>
            </div>
          </div>

          <div className="col-6 col-lg-3">
            <div
              className="card shadow-sm rounded-4 h-100 overflow-hidden"
              style={{
                background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
                position: "relative",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow =
                  "0 10px 20px rgba(0, 0, 0, 0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(0, 0, 0, 0.1)";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-15%",
                  left: "-15%",
                  width: "140px",
                  height: "140px",
                  background:
                    "linear-gradient(135deg, rgba(34, 197, 94, 0.15), rgba(187, 247, 208, 0.1))",
                  borderRadius: "50%",
                  filter: "blur(50px)",
                  opacity: "0.7",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: "-20%",
                  right: "-20%",
                  width: "120px",
                  height: "120px",
                  background:
                    "linear-gradient(135deg, rgba(34, 197, 94, 0.12), rgba(187, 247, 208, 0.08))",
                  borderRadius: "50%",
                  filter: "blur(40px)",
                  opacity: "0.5",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "4px",
                  background: "linear-gradient(90deg, #16a34a, #22c55e)",
                  borderRadius: "4px 4px 0 0",
                }}
              ></div>
              <div
                className={`card-body d-flex justify-content-between align-items-center ${
                  isMobile ? "p-3" : "p-4"
                }`}
              >
                <div>
                  <h5
                    className="fw-bold m-0"
                    style={{ fontSize: "1.2rem", color: "#14532d" }}
                  >
                    {summary?.paid_count || 0}
                  </h5>
                  <span className="fw-medium" style={{ fontSize: "0.8rem" }}>
                    Paid Employee
                  </span>
                </div>
                <span
                  className="d-none rounded-3 d-sm-flex justify-content-center align-items-center"
                  style={{
                    padding: "0.7rem",
                    background: "linear-gradient(135deg, #16a34a, #22c55e)",
                    boxShadow: "0 4px 10px rgba(22, 163, 74, 0.3)",
                  }}
                >
                  <FaCheckCircle size={22} color="white" />
                </span>
              </div>
            </div>
          </div>

          <div className="col-6 col-lg-3">
            <div
              className="card shadow-sm rounded-4 h-100 overflow-hidden"
              style={{
                background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
                position: "relative",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow =
                  "0 10px 20px rgba(0, 0, 0, 0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(0, 0, 0, 0.1)";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-15%",
                  left: "-15%",
                  width: "140px",
                  height: "140px",
                  background:
                    "linear-gradient(135deg, rgba(234, 179, 8, 0.15), rgba(254, 243, 199, 0.1))",
                  borderRadius: "50%",
                  filter: "blur(50px)",
                  opacity: "0.7",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: "-20%",
                  right: "-20%",
                  width: "120px",
                  height: "120px",
                  background:
                    "linear-gradient(135deg, rgba(234, 179, 8, 0.12), rgba(254, 243, 199, 0.08))",
                  borderRadius: "50%",
                  filter: "blur(40px)",
                  opacity: "0.5",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "4px",
                  background: "linear-gradient(90deg, #eab308, #facc15)",
                  borderRadius: "4px 4px 0 0",
                }}
              ></div>
              <div
                className={`card-body d-flex justify-content-between align-items-center ${
                  isMobile ? "p-3" : "p-4"
                }`}
              >
                <div>
                  <h5
                    className="fw-bold m-0"
                    style={{ fontSize: "1.2rem", color: "#713f12" }}
                  >
                    {summary?.unpaid_count || 0}
                  </h5>
                  <span className="fw-medium" style={{ fontSize: "0.8rem" }}>
                    Unpaid Employee
                  </span>
                </div>
                <span
                  className="d-none rounded-3 d-sm-flex justify-content-center align-items-center"
                  style={{
                    padding: "0.7rem",
                    background: "linear-gradient(135deg, #eab308, #facc15)",
                    boxShadow: "0 4px 10px rgba(234, 179, 8, 0.3)",
                  }}
                >
                  <IoIosWarning size={22} color="white" />
                </span>
              </div>
            </div>
          </div>

          <div className="col-6 col-lg-3">
            <div
              className="card shadow-sm rounded-4 h-100 overflow-hidden"
              style={{
                background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
                position: "relative",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow =
                  "0 10px 20px rgba(0, 0, 0, 0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(0, 0, 0, 0.1)";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-15%",
                  left: "-15%",
                  width: "140px",
                  height: "140px",
                  background:
                    "linear-gradient(135deg, rgba(59, 130, 246, 0.15), rgba(147, 197, 253, 0.1))",
                  borderRadius: "50%",
                  filter: "blur(50px)",
                  opacity: "0.7",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: "-20%",
                  right: "-20%",
                  width: "120px",
                  height: "120px",
                  background:
                    "linear-gradient(135deg, rgba(59, 130, 246, 0.12), rgba(147, 197, 253, 0.08))",
                  borderRadius: "50%",
                  filter: "blur(40px)",
                  opacity: "0.5",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "4px",
                  background: "linear-gradient(90deg, #0ea5e9, #38bdf8)",
                  borderRadius: "4px 4px 0 0",
                }}
              ></div>
              <div
                className={`card-body d-flex justify-content-between align-items-center ${
                  isMobile ? "p-3" : "p-4"
                }`}
              >
                <div>
                  <h5
                    className="fw-bold m-0"
                    style={{ fontSize: "1.2rem", color: "#075985" }}
                  >
                    ₹ {formatToIndianNumber(summary?.total_paid_amount)}
                  </h5>
                  <span className="fw-medium" style={{ fontSize: "0.8rem" }}>
                    Total Payroll
                  </span>
                </div>
                <span
                  className="d-none rounded-3 d-sm-flex justify-content-center align-items-center"
                  style={{
                    padding: "0.7rem",
                    background: "linear-gradient(135deg, #0ea5e9, #38bdf8)",
                    boxShadow: "0 4px 10px rgba(14, 165, 233, 0.3)",
                  }}
                >
                  <SiVirustotal size={22} color="white" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Search & Table */}
      {checkLoading ? (
        <div className="my-3 text-center">
          <Spinner className="animation-border" size="sm" />
        </div>
      ) : !isPayrollCreated ? (
        <div className="alert alert-warning text-center rounded-3 py-4">
          <div className="mb-3">
            <h5 className="fw-bold mb-1 text-darker">Payroll Not Created</h5>
            <p className="mb-0 text-dark" style={{ fontSize: "0.9rem" }}>
              No payroll has been generated for this period. Please create
              payroll to proceed.
            </p>
          </div>
          <button
            className="btn btn-primary px-4 fw-semibold"
            onClick={handleCreatePayroll}
            disabled={careatePayrollLoading}
          >
            {careatePayrollLoading && <Spinner animation="border" size="sm" />}
            Create Payroll
          </button>
        </div>
      ) : (
        <div className="card shadow-sm">
          <div className="p-3 d-flex justify-content-between align-items-center flex-wrap gap-2">
            <h4 className="mb-0">Employee Salaries</h4>
            <div className="d-flex gap-2 flex-wrap flex-fill flex-sm-grow-0">
              <div className="flex-fill">
                <DebounceSmallSearchInput
                  handleSearchChange={handleSearchChange}
                />
              </div>
              {/* <div>
                <GlobalSearchableDropdown
                  options={servicecenterOption}
                  selected={selectedServiceCenter}
                  onSelect={(item) => setSelectedServiceCenter(item)}
                  placeholder="Service center"
                />
              </div> */}
              {selectedEmployees.length > 0 && (
                <button
                  className="btn btn-primary align-self-center"
                  onClick={handleBulkPayment}
                  style={{ padding: "0.44rem 0.7rem" }}
                >
                  Pay Selected ({selectedEmployees.length})
                </button>
              )}
            </div>
          </div>
          {loading ? (
            <div className="my-3 text-center">
              <Spinner animation="border" />
            </div>
          ) : data && data?.length > 0 ? (
            <DoorStepEmployeeSalaryTable
              employees={data}
              setEmployees={setData}
              onPayEmployee={handlePayEmployee}
              selectedEmployees={selectedEmployees}
              onSelectEmployee={toggleEmployeeSelection}
              onSelectAll={handleSelectAllEmployees}
            />
          ) : (
            <div className="text-center my-3">No data found</div>
          )}
          {!loading && data?.length > 0 && (
            <div className="p-4">
              <Pagination
                currentPage={param.page}
                recordsPage={param.page_size}
                dataLength={total}
                handlePagination={handlePageChange}
              />
            </div>
          )}
        </div>
      )}

      {/* Single Payment Modal */}
      <DoorStepEmployeePaymentModal
        isOpen={isPaymentModalOpen}
        onClose={() => setIsPaymentModalOpen(false)}
        employee={selectedEmployee}
        onPaymentSuccess={handlePaymentSuccess}
      />

      {/* Bulk Payment Modal */}
      <DoorStepEmployeePaymentModal
        isOpen={isBulkPaymentModalOpen}
        onClose={() => setIsBulkPaymentModalOpen(false)}
        employees={selectedEmployees}
        onPaymentSuccess={handlePaymentSuccess}
        isBulkPayment={true}
      />
    </>
  );
}
